var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvestment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 1.25C17.5858 1.25 17.25 1.58579 17.25 2C17.25 2.41421 17.5858 2.75 18 2.75H20.253L12.5888 10.8176C12.4994 10.9117 12.3528 10.9217 12.2514 10.8406L6.16743 5.97348C5.47112 5.41643 4.46731 5.47203 3.83678 6.10256L1.46967 8.46967C1.17678 8.76256 1.17678 9.23744 1.46967 9.53033C1.76256 9.82322 2.23744 9.82322 2.53033 9.53033L4.89744 7.16322C4.98752 7.07314 5.13092 7.0652 5.23039 7.14478L11.3143 12.0119C12.0241 12.5797 13.0503 12.5097 13.6763 11.8507L21.25 3.8784V6C21.25 6.41421 21.5858 6.75 22 6.75C22.4142 6.75 22.75 6.41421 22.75 6V2C22.75 1.58579 22.4142 1.25 22 1.25H18Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 11.1838C17 10.53 17.53 10 18.1838 10H20.8162C21.47 10 22 10.53 22 11.1838V20.8162C22 21.47 21.47 22 20.8162 22H18.1838C17.53 22 17 21.47 17 20.8162V11.1838Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.18382 11C3.53002 11 3 11.53 3 12.1838V20.8162C3 21.47 3.53002 22 4.18382 22H6.81618C7.46998 22 8 21.47 8 20.8162V12.1838C8 11.53 7.46998 11 6.81618 11H4.18382Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1838 14C10.53 14 10 14.53 10 15.1838V20.8162C10 21.47 10.53 22 11.1838 22H13.8162C14.47 22 15 21.47 15 20.8162V15.1838C15 14.53 14.47 14 13.8162 14H11.1838Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestment);
export default __webpack_public_path__ + "static/media/investment.d759e6b1859ee4e8c897183f2c4711b7.svg";
export { ForwardRef as ReactComponent };